import axios from 'axios';
import { API_BASE_URL } from './api';

const API = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const PublicService = {
  // Verify certificate by number
  verifyCertificate: async (certificateNumber) => {
    try {
      console.log('🔍 Verifying certificate:', certificateNumber);
      const response = await API.get(`/public/verify/${certificateNumber}`);
      console.log('✅ Verification result:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Verification error:', error);
      throw error;
    }
  }
};

export default PublicService;